import { ReactComponent as SepratorMobile } from "../../images/pattern-divider-mobile.svg"
import { ReactComponent as SepratorDesktop } from "../../images/pattern-divider-desktop.svg"


import { useMediaQuery } from "react-responsive"

const Advice = ({ advice }) => {


    const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 768px )' })


    return (
        <>
            <div className="title">ADVICE #{advice?.id}</div>
            <div className="advice">{advice?.advice}</div>
            <div className="separetor">
                {!isDesktopOrLaptop ? <SepratorMobile ></SepratorMobile> : <SepratorDesktop ></SepratorDesktop>}
            </div>
        </>
    )
}

export default Advice